import * as React from "react";
import { css } from "emotion";
import { fonts } from "../shared/config";

/**
 * Headline properties.
 */
interface HeadlineProps {
  /** The headline of the story. */
  text: string;
  /** Custom css for the headline component */
  style?: string;
  /** The paragraphs of content for the story. */
  content: {
    type: string;
    value: any;
  }[];
}

/** The story's headline. */
export default function Headline(props: HeadlineProps) {
  return (
    <div
      className={css`
        margin-top: 40px;
        margin-bottom: 0px;
        font-family: sans-serif;
        font-family: ${fonts.textFont};
      `}
    >
      {props.text != "" && (
        <h1
          className={css`
            font-family: sans-serif;
            font-family: ${fonts.textFont};
            font-size: 48px;
            /* identical to box height */

            /* display: flex; */
            align-items: center;
            text-align: center;
            font-weight: 300;
            margin: 0 10px;
            color: #3d3d3d;
          `}
        >
          {props.text}
        </h1>
      )}

      <article
        className={css`
          margin-left: auto;
          margin-right: auto;
          margin-top: 0;
          max-width: 700px;
          padding: 1rem;
          text-align: justify;
          font-family: sans-serif;
          font-family: ${fonts.textFont};
        `}
      >
        {props.content && props.content.map(e => <p>{e.value}</p>)}
      </article>
    </div>
  );
}
